export default function StatusFilter({ options, value, onChange }) {
  return (
    <div className="flex gap-1 flex-wrap mb-2">
      {options.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border transition-colors ${
            value === o.key
              ? 'bg-navy text-white border-gold'
              : 'bg-white text-gray-500 border-gray-200 hover:border-gold'
          }`}
        >
          {o.label} ({o.count})
        </button>
      ))}
    </div>
  );
}
